<template>
  <div class="archives-viewer-tabs-content">
    <ArchiveListSection
      :id="entity"
      :contents="details.results"
      @focus-content="$emit('focus-archive', $event)"
      @bulk-delete="$emit('bulk-delete', $event)"
      @launch-search="$emit('launch-search', $event)"
    />
    <BasePagination
      v-if="details.pages > 1 && count > details.pageSize"
      :pageCount="details.pages"
      :perPage="details.pageSize"
      :value="details.page"
      :align="'center'"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import ArchiveListSection from './ArchiveListSection';
import BasePagination from '@/components/BasePagination';

export default {
  name: 'ArchivesViewerTabContent',
  components: {
    ArchiveListSection,
    BasePagination,
  },
  props: {
    entity: {
      type: String,
      default: '',
    },
    details: {
      type: Object,
      default: () => ({
        results: [],
        total: 0,
        pages: 0,
        pageSize: 10,
        page: 1,
        search: '',
      }),
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
